import { FC, useContext } from 'react';
import { Menu } from '@chakra-ui/react';

import {
  ApplicationContext,
  DocumentDetailsViewActionContext,
} from '../Layout.component';

export const GreenIdCheckMenuItem: FC = () => {
  const { actionContexts } = useContext(ApplicationContext);

  const {
    action: { text, key },
  } = useContext(DocumentDetailsViewActionContext);

  const { modal } = actionContexts[key];

  return (
    <Menu.Item onClick={modal.onOpen} value="green-id-check">
      {text}
    </Menu.Item>
  );
};
